module.exports = __webpack_public_path__ + "static/media/faq-illustration-min.8b259a0f.webp";